export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "Kredit AI Anda tidak cukup untuk membuat laporan ini. Silakan hubungi administrator Anda.",
      REPORT_ACCESS_DENIED: "Laporan AI ini tidak diaktifkan untuk akun Anda.",
      NOT_FOUND: "Laporan yang diminta tidak dapat ditemukan.",
      INVALID_INPUT: "Beberapa detail yang diberikan tidak valid. Silakan periksa dan coba lagi.",
      INVALID_GEOMETRY: "Area yang dipilih tidak valid. Silakan sesuaikan geofence dan coba lagi.",
    },
    usersByStatus: "Pengguna Berdasarkan Status",
    usersByGender: "Pengguna Berdasarkan Jenis Kelamin",
    gen: "Jenis Kelamin",
    gender: "Jenis Kelamin",
    male: "Laki-laki",
    female: "Perempuan",
    other: "Lainnya",
    unspecified: "Tidak Disebutkan",
    byCountry: "Berdasarkan Negara",
    avgPriceFarmer: "Harga Rata-rata Petani",
    avgPrice: "Harga Rata-rata",
    selectYear: "Pilih Tahun",
    total: "Total",
    farmerName: "Nama Petani",
    farmerProdChart: "Grafik Produksi Petani",
    production: "Produksi",
    byProduction: "Berdasarkan Produksi",
    byName: "Berdasarkan Nama",
    descending: "Menurun",
    ascending: "Menaik",
    buyingStationProdChart: "Grafik Produksi Stasiun Pembelian",
    buyingStation: "Stasiun Pembelian",
    buyingStationName: "Nama Stasiun Pembelian",
    dryMilling: "Penggilingan Kering",
    dryMillingName: "Nama Penggilingan Kering",
    dryMillingProdChart: "Grafik Produksi Penggilingan Kering",
    view: "Lihat",
    date: "Tanggal",
    reports: "Laporan",
    today: "Hari Ini",
    week: "Minggu",
    month: "Bulan",
    year: "Tahun",
    all: "Semua",
    selectCrop: "Pilih Tanaman",
    selectRegion: "Pilih Wilayah",
    selectProvinceState: "Pilih Provinsi/Negara Bagian",
    downloadPdfReport: "Unduh Laporan PDF",
    export: "Ekspor",
    search: "Cari",
    yield: "Hasil",
    avgAreaPerUnit: "Rata-rata Luas dalam {unit}",
    yieldPerUnit: "Hasil/{unit}",
    averageSellingPriceByAllFarmers: "Harga Jual Rata-rata oleh Semua Petani",
    averageSellingPricePerFarmer: "Harga Jual Rata-rata per Petani",
    pricePaid: "Harga Dibayar",
    pests: {
      pestReport: "Laporan Hama",
      filterByCrops: "Saring berdasarkan Tanaman",
      pestStatistics: "Statistik Hama",
      regions: "Wilayah",
      occurrences: "Kejadian",
      pestChart: "Grafik Hama",
      totalArea: "Total Area",
      pestName: "Nama Hama",
      region: "Wilayah",
      crop: "Tanaman",
      listByLand: "Daftar berdasarkan Lahan",
    },
    regions: {
      regionalReport: "Laporan Regional",
      listByFarm: "Daftar berdasarkan Pertanian",
      listByFarmers: "Daftar berdasarkan Petani",
      listByYield: "Daftar berdasarkan Hasil",
      regionalStatistics: "Statistik Regional",
      countries: "Negara",
      states: "Negara Bagian/Provinsi",
      city: "Kota",
      farmsIn: "Pertanian di",
      regionalChart: "Grafik Regional",
      farms: "Pertanian",
      regionName: "Nama Wilayah",
      farmers: "Petani",
      yield: "Hasil",
    },
    dashboard: {
      topCharts: "Grafik Teratas",
      regions: "Wilayah",
      noOfFarms: "Jumlah Pertanian",
      provinces: "Provinsi",
      landArea: "Luas Lahan",
      avgFarmerLand: "Lahan Petani Rata-rata",
      viewAll: "Lihat Semua",
      crops: "Tanaman",
      plantedAreaCrop: "Area Tanam Tanaman",
      plantedArea: "Area Tanam",
      avgYieldCrop: "Hasil Rata-rata Tanaman",
      averageYield: "Hasil Rata-rata",
      yieldChart: "Grafik Hasil",
      selectFarm: "Pilih Pertanian",
      soilQuality: "Kualitas Tanah",
      pests: "Hama",
      occurrences: "Kejadian",
      equipments: "Peralatan",
      goalAchievedChart: "Grafik Pencapaian Target",
      soilValues: "Nilai Tanah",
      soil: "Tanah",
      showReport: "Tampilkan Laporan",
      selectAll: "Pilih Semua",
    },
    weight: "Berat",
    quality: "Kualitas",
    price: "Harga",

    yieldPrediction: "Prediksi Hasil Panen",
    listOfReports: "Daftar Laporan",
    noYieldPredictionReportsFound: "Tidak ada laporan prediksi hasil panen yang ditemukan",
    loadingYieldPredictions: "Memuat prediksi hasil panen...",
    createNewReport: "Buat Laporan Baru",

    howToUseReport: "Bagaimana Cara Menggunakan Laporan?",
    viewGuide: "Lihat Panduan",
    cancel: "Batal",
    generateReport: "Hasilkan Laporan",
    selectFarmGeofence: "Pilih Geofence Pertanian",
    selectFarmGeofenceDescription: "Pilih pertanian yang terdaftar, gambar batas pertanian Anda di peta, atau masukkan lokasi untuk mulai menganalisis prediksi hasil panen area pertanian Anda.",
    point: "Titik",
    geofence: "Geofence",
    selectFarmZone: "Pilih Pertanian/Zona",
    select: "Pilih",
    latitude: "Lintang",
    longitude: "Bujur",
    uploadGeojsonFile: "Unggah File GeoJSON",
    uploadGeojsonFileDescription: "Pilih file GeoJSON dengan geofence Anda dari komputer Anda dan unggah. Hanya satu geofence yang akan diunggah dalam satu waktu, meskipun file Anda berisi beberapa geofence.",
    selectAFile: "Pilih File",
    hideAdvanced: "Sembunyikan Lanjutan",
    showAdvancedVariation: "Tampilkan Variasi Lanjutan",
    uploadHistoricalYieldDataDescription: "Silakan unggah data hasil panen historis pertanian Anda",
    showInstructions: "Tampilkan Instruksi",
    downloadTemplate: "Unduh Template",
    chooseFile: "Pilih File",
    noFileSelected: "Tidak ada file yang dipilih",
    yieldPredictionGuide: "Panduan Prediksi Hasil Panen",
    forecastedYields: "Hasil Panen yang Diperkirakan",
    farmArea: "Luas Pertanian",
    yieldForecasts: "Perkiraan Hasil Panen",
    graph: "Grafik",
    actualYields: "Hasil Panen Aktual",
    predictedFutureYields: "Hasil Panen Masa Depan yang Diprediksi",
    averageYields: "Hasil Panen Rata-rata",
    yieldTrendsGraph: "Grafik Tren Hasil Panen",
    step1: "Langkah 1",
    step2: "Langkah 2",
    step3: "Langkah 3",
    step4: "Langkah 4",
    satelliteMapView: "Tampilan Peta Satelit",
    selectYourFarm: "Pilih pertanian Anda dari menu drop-down (jika sudah terdaftar).",
    selectCropType: "Pilih jenis tanaman:",
    clickGenerateReport: "Klik 'Hasilkan Laporan' untuk melihat laporan prediksi hasil panen Anda.",
    howToGenerateReport: "Bagaimana Cara Menghasilkan Laporan?",
    howToInterpretReport: "Bagaimana Cara Menafsirkan Laporan?",
    tip: "Tip",

    disclaimer: "Penafian",
    disclaimer1: "Tidak mungkin memprediksi cuaca secara akurat untuk seluruh musim. Misalnya, hujan es atau banjir dapat terjadi kapan saja, yang dapat secara signifikan memengaruhi prediksi hasil panen.",
    disclaimer2: "Hasil panen sangat bergantung pada praktik manajemen petani. Misalnya, penerapan pestisida yang tepat waktu atau irigasi yang tepat dapat sangat memengaruhi hasil panen akhir.",
    disclaimer3: "Ada faktor lain yang dapat menyebabkan kesalahan signifikan dalam prediksi hasil panen AI.",
    startYear: "Tahun Mulai",
    endYear: "Tahun Berakhir",
    back: "Kembali",
    deleteReport: "Hapus Laporan",
    confirmDeleteReport: "Apakah Anda yakin ingin menghapus laporan prediksi hasil panen ini? Tindakan ini tidak dapat dibatalkan dan semua data terkait akan dihapus secara permanen.",
    deleteConfirmation: "Konfirmasi Penghapusan",
    download: "Unduh",
    report: "Laporan",
    dateOfReport: "Tanggal Laporan",
    farm: "Pertanian",
    location: "Lokasi",
    zone: "Zona",
    crop: "Tanaman",
    farmers: "Petani",
    yieldPerAcre: "Hasil/Acre",
    yieldPerHectare: "Hasil/Hektar",
    predictionModel: "Model Prediksi",
    accuracy: "Akurasi (R²)",
    confidence: "Kepercayaan",
    producer: "Produsen",
    reportDeletedSuccessfully: "Laporan berhasil dihapus",
    failedToDeleteReport: "Gagal menghapus laporan",
    enterHere: "Masukkan di sini",
    hectares: "hektar",
    whatIsYieldReportTitle: "Apa itu Laporan Prediksi Hasil Panen?",
    yieldReportDescription: "Laporan Prediksi Hasil Panen membantu Anda memperkirakan hasil panen tanaman untuk pertanian Anda menggunakan data historis, data satelit, dan model prediktif berbasis AI. Laporan ini memberi Anda perkiraan berapa banyak tanaman yang mungkin Anda panen di tahun saat ini dan tahun-tahun mendatang. Laporan ini memberikan wawasan tentang hasil panen aktual, hasil panen masa depan yang diprediksi, dan hasil panen rata-rata, memungkinkan Anda untuk mengoptimalkan operasi pertanian Anda dan merencanakan ke depan.",
    creatingYourReportEasy: "Membuat laporan Anda mudah:",
    selectYourFarmDescription: "Batas akan muncul di peta. Atau, gambar batas pertanian Anda (poligon atau titik) secara manual di peta jika belum terdaftar. Anda juga dapat mencari dengan mengetik Lintang dan Bujur untuk memperbesar lokasi.",
    selectCropTypeDescription: "Pilih tanaman yang ingin Anda analisis dari menu drop-down.",
    clickGenerateReportDescription: "untuk melihat laporan prediksi hasil panen Anda.",
    interpretReportIntro: "Setelah laporan dihasilkan, Anda akan melihat perkiraan hasil panen untuk tahun saat ini dan tahun mendatang. Grafik menampilkan tren hasil panen untuk pertanian Anda dengan tiga garis:",
    blueLineActualYields: "Garis Biru (Hasil Panen Aktual):",
    blueLineDescription: "Mewakili hasil panen sebenarnya dari musim sebelumnya di pertanian Anda. Ini membantu Anda memahami tren kinerja masa lalu dari waktu ke waktu.",
    redLinePredictedYields: "Garis Merah (Hasil Panen Masa Depan yang Diprediksi):",
    redLineDescription: "Menampilkan perkiraan berbasis AI untuk hasil panen mendatang. Ini memberikan perkiraan tentang apa yang dapat Anda harapkan (berapa banyak yang mungkin Anda panen) berdasarkan data dan tren saat ini.",
    brownLineAverageYields: "Garis Coklat (Hasil Panen Rata-rata):",
    brownLineDescription: "Menunjukkan hasil panen rata-rata di seluruh data yang tersedia untuk pertanian. Garis ini berfungsi sebagai patokan untuk membantu Anda membandingkan hasil panen historis dan yang diprediksi dengan tren keseluruhan.",
    highPredictedYieldsLabel: "Hasil panen tinggi yang diprediksi",
    highPredictedYieldsDescription: "menunjukkan bahwa praktik saat ini efektif. Pertahankan strategi Anda dan terapkan di area lain pertanian Anda.",
    lowPredictedYieldsLabel: "Hasil panen rendah yang diprediksi",
    lowPredictedYieldsDescription: "dapat menunjukkan area perbaikan, seperti jadwal penanaman, kesehatan tanah, penggunaan pupuk, irigasi, manajemen hama, stres air atau defisiensi nutrisi dll. Selidiki dan atasi masalah ini sejak dini untuk menghindari kerugian hasil panen lebih lanjut.",
    tipDescription: "Anda dapat menyimpan, mengunduh, atau menghapus laporan Anda untuk referensi di masa mendatang.",
    validationError: "Kesalahan Validasi",
    pleaseSelectCrop: "Silakan pilih tanaman",
    pleaseEnterLatLng: "Silakan masukkan lintang dan bujur atau pilih titik di peta",
    pleaseDrawGeofence: "Silakan gambar geofence di peta atau unggah file GeoJSON",
    invalidGeojsonFile: "File GeoJSON tidak valid",
    invalidGeojsonFileDescription: "Pastikan file dalam format GeoJSON yang valid.",
    errorReadingFile: "Kesalahan membaca file",
    failedToReadGeojson: "Gagal membaca file GeoJSON. Silakan coba lagi.",
    yieldReportGeneratedSuccessfully: "Laporan prediksi hasil panen berhasil dihasilkan",
    failedToGenerateReport: "Gagal menghasilkan laporan. Silakan coba lagi.",
    farmAndFarmId: "Pertanian & ID Pertanian",
    producerName: "Nama Produsen",
    failedToLoadReport: "Gagal memuat laporan prediksi hasil panen",
    reportDataNotLoaded: "Data laporan belum dimuat. Silakan tunggu dan coba lagi.",
    pdfGeneratedSuccessfully: "PDF berhasil dihasilkan",
    failedToGeneratePdf: "Gagal menghasilkan PDF. Silakan coba lagi.",
    editMap: "Edit Peta",
    editMapDescription: "Fungsi pengeditan peta akan diimplementasikan di sini",
    noForecastDataAvailable: "Tidak ada data perkiraan yang tersedia",
    noGraphImageAvailable: "Tidak ada gambar grafik yang tersedia",
    // Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Dasbor Laporan AI",
    aiReports: "Laporan AI",
    dashboardGuide: "Dashboard Guide",
    aiReportBuilders: "AI Report Builders",
    aiInsightsAndAnalytics: "AI Insights and Analytics",
    reportTypeDistribution: "Report Type Distribution",
    reportType: "Report Type",
    reportsGenerated: "Reports Generated",
    recentAiReports: "Recent AI Reports",
    vegetationVigorAnalysis: "Vegetation Vigor Analysis",
    farmProductivityAnalysis: "Farm Productivity Analysis",
    anomaliesDetection: "Anomalies Detection",
    diseaseDetection: "Disease Detection",
    averageVegetationHealth: "Average Vegetation Health",
    diseaseDetectedThisMonth: "Disease Detected this Month",
    anomaliesThisMonth: "Anomalies this Month",
    predictedYieldTrend: "Predicted Yield Trend",
    comingSoon: "Segera hadir",
    reportBuilderComingSoon: "This AI report builder is coming soon.",
    loadingRecentReports: "Loading recent reports…",
    noRecentAiReports: "No recent AI reports found.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Lahan / zona",
    sourcePolygon: "Poligon",
    sourceCircle: "Lingkaran",
    sourceGeojson: "GeoJSON",
    radiusM: "Radius (m)",
    drawPolygon: "Gambar poligon",
    drawPolygonHelp: "Klik peta untuk menambah titik.",
    drawCircle: "Gambar lingkaran",
    drawCircleHelp: "Klik peta untuk menentukan pusat; atur radius di bawah atau seret lingkaran untuk mengubah ukuran.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Analisis produktivitas pertanian",
      listOfReports: "Daftar laporan",
      createNewReport: "Buat laporan baru",
      backToDashboard: "Kembali ke dasbor",
      generateReport: "Buat laporan",
      cancel: "Batal",
      back: "Kembali",
      deleteReport: "Hapus laporan",
      downloadReport: "Unduh laporan",
      aiReportGuide: "Panduan laporan AI",
      viewGuide: "Lihat panduan",
      howToUseReport: "Bagaimana menggunakan laporan?",
      search: "Cari",
      reportId: "ID laporan",
      farmAndFarmId: "Lahan & ID lahan",
      producerName: "Nama produsen",
      dateOfReport: "Tanggal laporan",
      status: "Status",
      statusCompleted: "Selesai",
      statusGenerating: "Sedang dibuat",
      statusFailed: "Gagal",
      location: "Lokasi",
      farm: "Lahan",
      zone: "Zona",
      actions: "Tindakan",
      view: "Lihat",
      delete: "Hapus",
      selectFarmGeofence: "Pilih geofence pertanian",
      selectFarmGeofenceHelp: "Pilih pertanian terdaftar, gambar batas di peta, atau unggah file GeoJSON.",
      selectFarmZone: "Pilih pertanian / zona",
      sourceFarmZone: "Lahan / zona",
      sourcePolygon: "Poligon",
      sourceCircle: "Lingkaran",
      sourceGeojson: "GeoJSON",
      radiusM: "Radius (m)",
      select: "Pilih",
      uploadGeojsonFile: "Unggah file GeoJSON",
      uploadGeojsonHelp: "Pilih file GeoJSON berisi geofence dari komputer Anda dan unggah. Hanya satu geofence yang diunggah sekaligus, meskipun file memiliki banyak geofence.",
      selectAFile: "Pilih file",
      drawPolygon: "Gambar poligon",
      drawPolygonHelp: "Klik peta untuk menambah titik.",
      drawCircle: "Gambar lingkaran",
      drawCircleHelp: "Klik peta untuk menentukan pusat; atur radius di bawah atau seret lingkaran untuk mengubah ukuran.",
      estimatedComputeCost: "Perkiraan biaya komputasi",
      totalCreditsRequired: "Total kredit yang diperlukan",
      creditsComingSoon: "Sistem kredit segera hadir.",
      reportDetails: "Detail laporan",
      generating: "Membuat laporan...",
      generatingHelp: "Laporan Anda sedang dibuat. Ini dapat memakan waktu beberapa menit.",
      failed: "Pembuatan laporan gagal.",
      reportDescription: "Laporan zona produktivitas menganalisis produktivitas area pertanian Anda berdasarkan kinerja historis dan indikator vegetasi.",
      disclaimerTitle: "PENAFIAN",
      disclaimer: "Laporan buatan AI ini dimaksudkan sebagai panduan. Untuk diagnosis akurat dan rekomendasi yang disesuaikan, kami sangat menyarankan berkonsultasi dengan ahli agronomi atau pertanian yang berkualifikasi.",
      zoneLabels: {
        "Lowest Productivity Zones": "Zona produktivitas terendah",
        "Low Productivity Zones": "Zona produktivitas rendah",
        "Moderate Productivity Zones": "Zona produktivitas sedang",
        "High Productivity Zones": "Zona produktivitas tinggi",
        "Highest Productivity Zones": "Zona produktivitas tertinggi",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Area dengan kinerja tanaman terburuk yang memerlukan perhatian atau intervensi segera.",
        "Low Productivity Zones": "Area dengan kinerja tanaman di bawah rata-rata yang perlu ditingkatkan.",
        "Moderate Productivity Zones": "Area dengan kinerja sedang yang mungkin memerlukan beberapa penyesuaian.",
        "High Productivity Zones": "Area dengan kinerja di atas rata-rata dan potensi hasil yang baik.",
        "Highest Productivity Zones": "Area dengan kinerja optimal dan potensi hasil tertinggi.",
      },
      feedback: "Umpan balik",
      doYouAgree: "Apakah Anda setuju dengan prediksi?",
      agree: "Setuju",
      disagree: "Tidak setuju",
      agreedWithPrediction: "Setuju dengan prediksi",
      disagreedWithPrediction: "Tidak setuju dengan prediksi",
      disagreeHelp: "Jika Anda tidak setuju dengan hasil ini, berikan umpan balik",
      addFeedback: "Tambah umpan balik",
      feedbackPlaceholder: "Masukkan di sini",
      attachmentsOptional: "Lampiran (opsional)",
      attachments: "Lampiran",
      download: "Unduh",
      attachmentsHelp: "Seret & lepas gambar atau video di sini, atau telusuri file. Format yang didukung: JPG, PNG, MP4.",
      selectFilesToUpload: "Pilih file untuk mengunggah data",
      orDragAndDrop: "atau seret dan lepas di sini",
      submit: "Kirim",
      feedbackSubmitted: "Umpan balik berhasil dikirim.",
      feedbackAlreadySubmitted: "Umpan balik sudah dikirim untuk laporan ini.",
      guideTitle: "Panduan zona produktivitas",
      guideStep: "Langkah {current} dari {total}",
      next: "Berikutnya",
      close: "Tutup",
      guideStep1Title: "Apa itu laporan zona produktivitas?",
      guideStep1Body: "Laporan zona produktivitas menganalisis produktivitas area dalam zona atau pertanian Anda dan mengklasifikasikannya menjadi zona hasil rendah, sedang, dan tinggi.",
      guideStep2Title: "Bagaimana cara membuat laporan?",
      guideStep2Body: "Membuat laporan mudah:\n\n1. Pilih pertanian dari menu dropdown (jika terdaftar) atau gambar/unggah batas.\n2. Buat laporan dan tunggu analisis selesai.",
      guideStep3Title: "Bagaimana menafsirkan laporan?",
      guideStep3Body: "Setelah dibuat, laporan menampilkan peta berkode warna yang membagi pertanian Anda menjadi tiga zona produktivitas.",
      guideTip: "Tips:",
      guideTipBody: "Mulailah dari zona oranye — mereka membutuhkan perbaikan paling mendesak. Pelajari zona hijau untuk mereplikasi praktik yang baik.",
      invalidGeojsonFile: "File GeoJSON tidak valid",
      invalidGeojsonFileDescription: "File yang dipilih bukan GeoJSON yang valid. Periksa dan coba lagi.",
      generateFailed: "Tidak dapat memulai pembuatan laporan. Silakan coba lagi.",
      loadFailed: "Tidak dapat memuat laporan. Silakan coba lagi.",
      deleteConfirmTitle: "Hapus laporan",
      deleteConfirmMessage: "Yakin ingin menghapus laporan ini? Tindakan ini tidak dapat dibatalkan.",
      deleted: "Laporan berhasil dihapus.",
      uploadFailed: "Unggah file gagal. Silakan coba lagi.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Deteksi anomali",
      reportComparison: "Perbandingan laporan",
      listOfReports: "Daftar laporan",
      createNewReport: "Buat laporan baru",
      backToDashboard: "Kembali ke dasbor",
      generateReport: "Buat laporan",
      cancel: "Batal",
      back: "Kembali",
      deleteReport: "Hapus laporan",
      downloadReport: "Unduh laporan",
      compareReports: "Bandingkan laporan",
      aiReportGuide: "Panduan laporan AI",
      search: "Cari",
      reportId: "ID laporan",
      farmAndFarmId: "Lahan & ID lahan",
      producerName: "Nama produsen",
      dateOfReport: "Tanggal laporan",
      status: "Status",
      statusCompleted: "Selesai",
      statusGenerating: "Sedang dibuat",
      statusPartial: "Sebagian",
      statusFailed: "Gagal",
      location: "Lokasi",
      farm: "Lahan",
      zone: "Zona",
      actions: "Tindakan",
      view: "Lihat",
      delete: "Hapus",
      selectFarmGeofence: "Pilih geofence pertanian",
      selectFarmGeofenceHelp: "Pilih pertanian terdaftar, gambar batas di peta, atau unggah file GeoJSON.",
      selectFarmZone: "Pilih pertanian / zona",
      sourceFarmZone: "Lahan / zona",
      sourcePolygon: "Poligon",
      sourceCircle: "Lingkaran",
      sourceGeojson: "GeoJSON",
      radiusM: "Radius (m)",
      select: "Pilih",
      uploadGeojsonFile: "Unggah file GeoJSON",
      uploadGeojsonHelp: "Pilih file GeoJSON berisi geofence dari komputer Anda dan unggah. Hanya satu geofence yang diunggah sekaligus, meskipun file memiliki banyak geofence.",
      selectAFile: "Pilih file",
      drawPolygon: "Gambar poligon",
      drawPolygonHelp: "Klik peta untuk menambah titik.",
      drawCircle: "Gambar lingkaran",
      drawCircleHelp: "Klik peta untuk menentukan pusat; atur radius di bawah atau seret lingkaran untuk mengubah ukuran.",
      detectAnomalies: "Deteksi anomali",
      detectAnomaliesHelp: "Setelah menggambar atau mengunggah geofence, pilih tanggal yang diinginkan untuk mendeteksi anomali.",
      startDate: "Tanggal mulai",
      fetchingDates: "Mengambil tanggal yang tersedia...",
      noAvailableDates: "Tidak ada tanggal satelit yang tersedia untuk area ini.",
      selectDateToGenerate: "Pilih tanggal yang tersedia, lalu buat laporan.",
      numberOfHistoricalReports: "Jumlah laporan historis",
      historicalReportsPlaceholder: "Masukkan di sini",
      historicalReportsNote: "Meningkatkan jumlah ini akan mengonsumsi kredit AI tambahan untuk setiap gambar historis yang diminta.",
      estimatedComputeCost: "Perkiraan biaya komputasi",
      totalCreditsRequired: "Total kredit yang diperlukan",
      creditsComingSoon: "Sistem kredit segera hadir.",
      selectDate: "Pilih tanggal",
      reportDetails: "Detail laporan",
      closestImageNote: "Citra satelit untuk {requested} tidak tersedia. Kami menggunakan citra terdekat yang tersedia.",
      generating: "Membuat laporan...",
      generatingHelp: "Laporan Anda sedang dibuat. Ini dapat memakan waktu beberapa menit.",
      partialWarning: "Beberapa tanggal tidak dapat dibuat untuk laporan ini.",
      failed: "Pembuatan laporan gagal.",
      disclaimerTitle: "PENAFIAN",
      disclaimer: "Laporan buatan AI ini dimaksudkan sebagai panduan. Untuk diagnosis akurat dan rekomendasi yang disesuaikan, kami sangat menyarankan berkonsultasi dengan ahli agronomi atau pertanian yang berkualifikasi.",
      greenAreas: "Area hijau",
      greenAreasDesc: "Kekuatan vegetasi saat ini mengungguli rata-rata historis",
      yellowAreas: "Area kuning",
      yellowAreasDesc: "Kekuatan vegetasi saat ini sesuai rata-rata historis",
      redAreas: "Area merah",
      redAreasDesc: "Area dengan kinerja tanaman buruk yang memerlukan perhatian atau intervensi segera.",
      underperforming: "Di bawah kinerja",
      outperforming: "Di atas kinerja",
      imageComparison: "Perbandingan laporan",
      sideComparison: "Perbandingan berdampingan",
      sliderComparison: "Perbandingan slider",
      transparencyComparison: "Perbandingan transparansi",
      transparencySlider: "Slider transparansi",
      notGeneratedPrompt: "Laporan ini belum dibuat untuk tanggal yang dipilih. Buat sekarang?",
      generateNow: "Buat sekarang",
      feedback: "Umpan balik",
      doYouAgree: "Apakah Anda setuju dengan prediksi?",
      agree: "Setuju",
      disagree: "Tidak setuju",
      agreedWithPrediction: "Setuju dengan prediksi",
      disagreedWithPrediction: "Tidak setuju dengan prediksi",
      disagreeHelp: "Jika Anda tidak setuju dengan hasil ini, berikan umpan balik",
      addFeedback: "Tambah umpan balik",
      feedbackPlaceholder: "Masukkan di sini",
      attachmentsOptional: "Lampiran (opsional)",
      attachments: "Lampiran",
      download: "Unduh",
      attachmentsHelp: "Seret & lepas gambar atau video di sini, atau telusuri file. Format yang didukung: JPG, PNG, MP4.",
      selectFilesToUpload: "Pilih file untuk mengunggah data",
      orDragAndDrop: "atau seret dan lepas di sini",
      submit: "Kirim",
      feedbackSubmitted: "Umpan balik berhasil dikirim.",
      feedbackAlreadySubmitted: "Umpan balik sudah dikirim untuk laporan ini.",
      guideTitle: "Panduan deteksi anomali",
      guideStep: "Langkah {current} dari {total}",
      next: "Berikutnya",
      close: "Tutup",
      guideStep1Title: "Apa itu deteksi anomali?",
      guideStep1Body: "Deteksi anomali membandingkan kinerja vegetasi saat ini dengan rata-rata historis untuk mengidentifikasi area yang berkinerja di atas atau di bawah harapan.",
      guideStep2Title: "Bagaimana cara membuat laporan?",
      guideStep2Body: "Membuat laporan mudah:\n\n1. Pilih pertanian dari menu dropdown (jika sudah terdaftar) atau gambar/unggah batas.\n2. Pilih tanggal yang tersedia dan buat laporan.",
      guideStep3Title: "Bagaimana menafsirkan laporan?",
      guideStep3Body: "Setelah dibuat, laporan menampilkan peta panas berkode warna berdasarkan perbandingan kekuatan vegetasi saat ini dengan historis.",
      guideTip: "Tips:",
      guideTipBody: "Perbandingan tanggal: laporan menyediakan peta panas untuk beberapa tanggal sehingga Anda dapat melacak perubahan dari waktu ke waktu.",
      invalidGeojsonFile: "File GeoJSON tidak valid",
      invalidGeojsonFileDescription: "File yang dipilih bukan GeoJSON yang valid. Periksa dan coba lagi.",
      geofenceRequired: "Pilih pertanian/zona, gambar geofence, atau unggah GeoJSON.",
      dateRequired: "Pilih tanggal yang tersedia.",
      generateFailed: "Tidak dapat memulai pembuatan laporan. Silakan coba lagi.",
      loadFailed: "Tidak dapat memuat laporan. Silakan coba lagi.",
      datesFailed: "Tidak dapat mengambil tanggal yang tersedia. Coba lagi.",
      deleteConfirmTitle: "Hapus laporan",
      deleteConfirmMessage: "Yakin ingin menghapus laporan ini? Tindakan ini tidak dapat dibatalkan.",
      deleted: "Laporan berhasil dihapus.",
      uploadFailed: "Unggah file gagal. Silakan coba lagi.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "PENAFIAN",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Umpan balik",
      doYouAgree: "Apakah Anda setuju dengan prediksi?",
      agree: "Setuju",
      disagree: "Tidak setuju",
      agreedWithPrediction: "Setuju dengan prediksi",
      disagreedWithPrediction: "Tidak setuju dengan prediksi",
      disagreeHelp: "Jika Anda tidak setuju dengan hasil ini, berikan umpan balik",
      addFeedback: "Tambah umpan balik",
      feedbackPlaceholder: "Masukkan di sini",
      attachmentsOptional: "Lampiran (opsional)",
      attachments: "Lampiran",
      download: "Unduh",
      attachmentsHelp: "Seret & lepas gambar atau video di sini, atau telusuri file. Format yang didukung: JPG, PNG, MP4.",
      selectFilesToUpload: "Pilih file untuk mengunggah data",
      orDragAndDrop: "atau seret dan lepas di sini",
      submit: "Kirim",
      feedbackSubmitted: "Umpan balik berhasil dikirim.",
      feedbackAlreadySubmitted: "Umpan balik sudah dikirim untuk laporan ini.",
      uploadFailed: "Unggah file gagal. Silakan coba lagi.",
    },

landSuitabilityDesign: {
      reportDetails: "Detail laporan",
      greenAreas: "Area hijau",
      greenAreasDesc: "Area yang dinilai sangat sesuai untuk tanaman yang dipilih",
      yellowAreas: "Area kuning",
      yellowAreasDesc: "Area dengan kesesuaian sedang yang mungkin memerlukan perhatian",
      redAreas: "Area merah",
      redAreasDesc: "Area yang dinilai tidak sesuai dan kemungkinan memerlukan intervensi",
      underperforming: "Di bawah kinerja",
      outperforming: "Di atas kinerja",
      feedback: "Umpan balik",
      doYouAgree: "Apakah Anda setuju dengan prediksi?",
      agree: "Setuju",
      disagree: "Tidak setuju",
      agreedWithPrediction: "Setuju dengan prediksi",
      disagreedWithPrediction: "Tidak setuju dengan prediksi",
      disagreeHelp: "Jika Anda tidak setuju dengan hasil ini, berikan umpan balik",
      addFeedback: "Tambah umpan balik",
      feedbackPlaceholder: "Masukkan di sini",
      attachmentsOptional: "Lampiran (opsional)",
      attachments: "Lampiran",
      download: "Unduh",
      attachmentsHelp: "Seret & lepas gambar atau video di sini, atau telusuri file. Format yang didukung: JPG, PNG, MP4.",
      selectFilesToUpload: "Pilih file untuk mengunggah data",
      orDragAndDrop: "atau seret dan lepas di sini",
      submit: "Kirim",
      feedbackSubmitted: "Umpan balik berhasil dikirim.",
      feedbackAlreadySubmitted: "Umpan balik sudah dikirim untuk laporan ini.",
      uploadFailed: "Unggah file gagal. Silakan coba lagi.",
    },
    cropProgression: {
      title: "Analisis kekuatan vegetasi",
      listOfReports: "Daftar laporan",
      createNewReport: "Buat laporan baru",
      backToDashboard: "Kembali ke dasbor",
      generateReport: "Buat laporan",
      cancel: "Batal",
      back: "Kembali",
      deleteReport: "Hapus laporan",
      downloadReport: "Unduh laporan",
      compareImages: "Bandingkan gambar",
      aiReportGuide: "Panduan laporan AI",
      search: "Cari",
      reportId: "ID laporan",
      farmAndFarmId: "Lahan & ID lahan",
      producerName: "Nama produsen",
      dateOfReport: "Tanggal laporan",
      selectedDate: "Tanggal laporan",
      status: "Status",
      statusCompleted: "Selesai",
      statusGenerating: "Sedang dibuat",
      statusPartial: "Sebagian",
      statusFailed: "Gagal",
      location: "Lokasi",
      farm: "Lahan",
      zone: "Zona",
      actions: "Tindakan",
      view: "Lihat",
      delete: "Hapus",
      selectFarmGeofence: "Pilih geofence lahan",
      selectFarmGeofenceHelp: "Pilih lahan terdaftar, gambar batas di peta, atau unggah GeoJSON untuk mulai menganalisis area Anda.",
      point: "Titik",
      geofence: "Geofence",
      selectFarmZone: "Pilih lahan / zona",
      sourceFarmZone: "Lahan / zona",
      sourcePolygon: "Poligon",
      sourceCircle: "Lingkaran",
      sourceGeojson: "GeoJSON",
      mapView: "Tampilan peta",
      latitude: "Lintang",
      longitude: "Bujur",
      radiusKm: "Radius (km)",
      radiusM: "Radius (m)",
      enterHere: "Masukkan di sini",
      select: "Pilih",
      uploadGeojsonFile: "Unggah file GeoJSON",
      uploadGeojsonHelp: "Pilih file GeoJSON berisi geofence dari komputer Anda dan unggah. Hanya satu geofence yang diunggah sekaligus, meskipun file memiliki banyak geofence.",
      selectAFile: "Pilih file",
      drawPolygon: "Gambar poligon",
      drawPolygonHelp: "Klik peta untuk menambah titik.",
      drawCircle: "Gambar lingkaran",
      drawCircleHelp: "Klik peta untuk menentukan pusat; atur radius di bawah atau seret lingkaran untuk mengubah ukuran.",
      clearDrawing: "Hapus",
      searchLocation: "Cari lokasi",
      closePolygonHint: "Klik titik pertama untuk menutup area",
      unnamedFarm: "Lahan #{id}",
      unnamedZone: "Zona #{id}",
      selectDate: "Pilih tanggal",
      availableDates: "Tanggal tersedia",
      fetchingDates: "Mengambil tanggal tersedia...",
      noAvailableDates: "Tidak ada tanggal satelit tersedia untuk area ini.",
      selectDateToGenerate: "Pilih tanggal yang tersedia, lalu buat laporan.",
      estimatedComputeCost: "Perkiraan biaya komputasi",
      totalCreditsRequired: "Total kredit yang dibutuhkan",
      creditsAvailable: "Kredit tersedia",
      creditsSufficient: "Kredit cukup untuk pembuatan laporan AI",
      reportType: "Jenis laporan",
      selectReportType: "Pilih jenis laporan",
      chooseIndexHelp: "Pilih indeks satelit untuk menganalisis pertumbuhan, kelembapan, atau nutrisi tanaman dari waktu ke waktu.",
      scale: "Skala",
      generating: "Membuat laporan...",
      generatingHelp: "Laporan Anda sedang dibuat. Ini bisa memakan waktu beberapa menit.",
      partialWarning: "Beberapa indeks tidak dapat dibuat untuk tanggal ini.",
      failed: "Pembuatan laporan gagal.",
      valuesCloseToOne: "Nilai mendekati 1 menunjukkan vegetasi yang lebih sehat",
      disclaimerTitle: "PENAFIAN",
      disclaimer: "Laporan buatan AI ini dimaksudkan sebagai panduan. Untuk diagnosis akurat dan rekomendasi yang disesuaikan, kami sangat menyarankan berkonsultasi dengan ahli agronomi atau pertanian yang berkualifikasi.",
      indexNDVI: "Kesehatan tanaman (NDVI)",
      indexMSAVI: "Pertumbuhan vegetasi tahap awal (MSAVI)",
      indexLSWI: "Kandungan kelembapan (LSWI)",
      indexRECI: "Estimasi tingkat nutrisi (RECI)",
      indexNDRE: "Kehijauan & kepadatan kanopi (NDRE)",
      reportComparison: "Perbandingan laporan kekuatan vegetasi",
      imageComparison: "Perbandingan gambar",
      sideComparison: "Perbandingan berdampingan",
      sliderComparison: "Perbandingan slider",
      transparencyComparison: "Perbandingan transparansi",
      transparencySlider: "Slider transparansi",
      notGeneratedPrompt: "Laporan ini belum dibuat untuk tanggal yang dipilih. Buat sekarang?",
      generateNow: "Buat sekarang",
      feedback: "Umpan balik",
      doYouAgree: "Apakah Anda setuju dengan prediksi?",
      agree: "Setuju",
      disagree: "Tidak setuju",
      agreedWithPrediction: "Setuju dengan prediksi",
      disagreedWithPrediction: "Tidak setuju dengan prediksi",
      disagreeHelp: "Jika Anda tidak setuju dengan hasil ini, berikan umpan balik Anda",
      addFeedback: "Tambah umpan balik",
      feedbackPlaceholder: "Masukkan di sini",
      attachmentsOptional: "Lampiran (opsional)",
      attachments: "Lampiran",
      download: "Unduh",
      attachmentsHelp: "Seret & lepas gambar atau video di sini, atau telusuri file. Format yang didukung: JPG, PNG, MP4.",
      selectFilesToUpload: "Pilih file untuk mengunggah data",
      orDragAndDrop: "atau seret dan lepas di sini",
      submit: "Kirim",
      feedbackSubmitted: "Umpan balik berhasil dikirim.",
      feedbackAlreadySubmitted: "Umpan balik sudah dikirim untuk laporan ini.",
      guideTitle: "Panduan analisis kekuatan vegetasi",
      guideStep: "Langkah {current} dari {total}",
      next: "Berikutnya",
      close: "Tutup",
      guideStep1Title: "Apa itu laporan analisis kekuatan vegetasi?",
      guideStep1Body: "Analisis ini membantu mengidentifikasi area lahan dengan kekuatan vegetasi rendah agar Anda dapat bertindak tepat waktu. Laporan menggunakan citra satelit untuk menunjukkan seberapa sehat tanaman pada waktu tertentu.\n\nHeatmap menunjukkan bagian lahan yang mungkin perlu perhatian. Dengan membandingkan gambar dari tanggal berbeda, Anda dapat melacak apakah tanaman membaik atau menurun.",
      guideStep2Title: "Bagaimana cara membuat laporan?",
      guideStep2Body: "Membuat laporan mudah:\n\n1. Pilih lahan dari menu dropdown (jika sudah terdaftar). Batas akan muncul di peta. Atau gambar batas secara manual jika belum terdaftar.\n2. Pilih tanggal: tanggal yang ingin Anda lihat datanya.\n3. Klik \"Buat laporan\" untuk melihat analisis.",
      guideStep3Title: "Bagaimana menafsirkan laporan?",
      guideStep3Body: "Setelah dibuat, Anda akan melihat heatmap lahan dengan warna hijau, kuning, dan merah.\n\nHijau = Kekuatan vegetasi tinggi\nKuning/Merah = Kekuatan lebih rendah → mungkin perlu perhatian\n\nKekuatan rendah dapat disebabkan panen, tanah buruk, hama, atau cuaca terkini.",
      guideTip: "Tips:",
      guideTipBody: "Gunakan sakelar tanggal di bawah heatmap untuk melihat beberapa laporan dan melacak perubahan kesehatan tanaman. Anda dapat menyimpan, mengunduh, atau menghapus laporan kapan saja.",
      additionalReportTypes: "Jenis laporan tambahan yang tersedia:",
      invalidGeojsonFile: "File GeoJSON tidak valid",
      invalidGeojsonFileDescription: "File yang dipilih bukan GeoJSON yang valid. Periksa dan coba lagi.",
      geofenceRequired: "Pilih lahan/zona, gambar geofence, atau unggah GeoJSON.",
      dateRequired: "Pilih tanggal yang tersedia.",
      generateFailed: "Tidak dapat memulai pembuatan laporan. Silakan coba lagi.",
      loadFailed: "Tidak dapat memuat laporan. Silakan coba lagi.",
      datesFailed: "Tidak dapat mengambil tanggal tersedia. Silakan coba lagi.",
      deleteConfirmTitle: "Hapus laporan",
      deleteConfirmMessage: "Yakin ingin menghapus laporan ini? Tindakan ini tidak dapat dibatalkan.",
      deleted: "Laporan berhasil dihapus.",
      uploadFailed: "Unggah file gagal. Silakan coba lagi.",
    },
    aiClient: {
      credits: "Kredit",
      cancel: "Batal",
      save: "Simpan",
      back: "Kembali",
      close: "Tutup",
      search: "Cari",
      makeSelection: "Buat pilihan",
      errorTitle: "Kesalahan",
      successTitle: "Berhasil",
      loadFailed: "Data tidak dapat dimuat. Silakan coba lagi.",
      saveFailed: "Tidak dapat menyimpan. Silakan coba lagi.",
      saved: "Pengaturan berhasil disimpan.",
      rt_vegetation_vigor: "Kekuatan vegetasi",
      rt_farm_productivity: "Produktivitas lahan",
      rt_anomaly_detection: "Deteksi anomali",
      rt_yield_prediction: "Prediksi hasil panen",
      rt_disease_detection: "Deteksi penyakit",
      rt_land_suitability: "Kesesuaian lahan",
      dashTitle: "Dasbor laporan AI",
      dashGuide: "Panduan dasbor",
      builders: "Pembuat laporan AI",
      distributionTitle: "Distribusi jenis laporan",
      colReportType: "Jenis laporan",
      colReportsGenerated: "Laporan yang dibuat",
      recentTitle: "Laporan AI terbaru",
      noRecent: "Belum ada laporan yang dibuat.",
      noDistribution: "Belum ada aktivitas laporan.",
      na: "N/A",
      bVegetationVigor: "Analisis kekuatan vegetasi",
      bFarmProductivity: "Analisis produktivitas lahan",
      bAnomalies: "Deteksi anomali",
      bYield: "Prediksi hasil panen",
      bDisease: "Deteksi penyakit",
      bLand: "Kesesuaian lahan",
      insightsTitle: "Wawasan dan analitik AI",
      iVegHealth: "Kesehatan vegetasi rata-rata",
      iDisease: "Penyakit terdeteksi bulan ini",
      iAnomalies: "Anomali bulan ini",
      iYieldTrend: "Tren hasil panen yang diprediksi",
      creditsAvailableLabel: "Tersedia",
      totalCredits: "Total kredit:",
      creditsUsedLabel: "Kredit digunakan:",
      topUp: "Isi ulang kredit",
      topUpInfo: "Hubungi administrator Anda untuk mengisi ulang kredit.",
      creditsHistory: "Riwayat kredit",
      manageBtn: "Kelola laporan AI & kredit",
      manageTitle: "Kelola laporan AI & kredit",
      usageLogBtn: "Log penggunaan kredit",
      cardAvailable: "Kredit tersedia",
      cardTotal: "Total kredit",
      cardUsed: "Kredit digunakan",
      refreshesOn: "Diperbarui pada",
      assignedOn: "Ditugaskan pada",
      distBudgetTitle: "Distribusi & penganggaran laporan AI",
      distBudgetHelp: "Konfigurasikan akses laporan AI untuk serikat, pabrik, dan petani Anda. Alokasikan anggaran kredit spesifik ke setiap tingkat untuk mengelola konsumsi sumber daya koperasi secara efisien.",
      group_cooperative: "Koperasi",
      group_buying_station: "Stasiun pembelian",
      group_farmer: "Petani",
      monthlyCredits: "Kredit bulanan",
      aiReports: "Laporan AI",
      enabled: "Diaktifkan",
      disabled: "Dinonaktifkan",
      overAllocation: "Alokasi grup melebihi anggaran kredit koperasi.",
      usageLogTitle: "Log penggunaan kredit",
      filterCooperative: "Koperasi",
      filterReport: "Laporan AI",
      colDateTime: "Tanggal & waktu",
      colEntity: "Entitas",
      colAiReport: "Laporan AI",
      colCreditsUsed: "Kredit digunakan",
      colBalance: "Saldo",
      historyTitle: "Riwayat kredit",
      historyDesc: "Ringkasan alokasi kredit dibandingkan konsumsi untuk koperasi ini. Gunakan ringkasan ini untuk melacak tren penggunaan bulanan dan siklus penagihan.",
      coopLabel: "Koperasi",
      colMonth: "Bulan",
      colCreditsAssigned: "Kredit yang dialokasikan",
      colClosingBalance: "Saldo penutupan",
      noHistory: "Belum ada riwayat kredit.",
      guideTitle: "Panduan dasbor laporan AI Dimitra",
      guideStep: "Langkah",
      guideOf: "dari",
      guideClose: "Tutup",
      guideSkip: "Lewati",
      guideNext: "Berikutnya",
      guideBack: "Kembali",
      guideDone: "Tutup",
      g1Title: "Ikhtisar dasbor",
      g1Intro: "Selamat datang di pusat wawasan AI Anda. Panduan ini akan membantu Anda menafsirkan peta, mengelola kredit, dan menggunakan model AI.",
      g1Points: [
        "Pahami wawasan peta: Gunakan filter pada peta untuk melihat provinsi dan wilayah tertentu. Heatmap memberikan tampilan kode warna instan atas kinerja lahan di seluruh koperasi, dengan kunci indikator Tinggi/Sedang/Rendah.",
        "Pantau kredit: Kredit tersedia Anda saat ini ditampilkan di pojok kanan atas. Pastikan saldo cukup sebelum membuat laporan besar.",
      ],
      g2Title: "Memahami laporan AI",
      g2Intro: "Dasbor Anda memberikan akses ke model AI khusus. Setiap laporan menganalisis aspek berbeda dari data pertanian Anda.",
      g2Points: [
        "Kekuatan vegetasi: Nilai kesehatan tanaman secara keseluruhan dan identifikasi area yang perlu perhatian.",
        "Produktivitas lahan: Analisis tren produktivitas historis untuk mengoptimalkan potensi hasil panen.",
        "Deteksi anomali: Temukan pola lahan tidak teratur yang mungkin menandakan stres atau ancaman eksternal.",
        "Prediksi hasil panen: Perkiraan hasil panen berdasarkan data pertumbuhan saat ini.",
        "Deteksi penyakit: Gunakan citra tanaman untuk segera mengidentifikasi penyakit spesifik.",
      ],
      g3Title: "Cara kerja kredit",
      g3Intro: "Dimitra menggunakan sistem berbasis kredit untuk mengelola konsumsi sumber daya AI. Kredit berfungsi sebagai mata uang untuk membuat laporan.",
      g3Points: [
        "Alokasi: Koperasi Anda diberi saldo bulanan oleh Administrator.",
        "Konsumsi: Setiap kali Anda membuat laporan, kredit dipotong dari saldo tersedia Anda.",
        "Visibilitas: Anda dapat melacak setiap potongan di buku kredit khusus Anda.",
      ],
      g4Title: "Pemantauan penggunaan & riwayat kredit",
      g4Intro: "Tetap kendalikan anggaran dengan memantau riwayat kredit Anda.",
      g4Points: [
        "Saldo tersedia: Selalu terlihat di kartu kanan atas. Perhatikan tanggal pembaruan untuk mengetahui kapan alokasi berikutnya tiba.",
        "Log penggunaan: Klik [Riwayat kredit] untuk melihat rincian laporan mana yang dibuat, kapan, dan oleh entitas mana (koperasi, serikat, pabrik, atau petani).",
        "Pengelolaan: Jika kredit hampir habis, gunakan tombol [Kelola laporan AI & kredit] untuk menyesuaikan anggaran tingkat entitas atau hubungi administrator untuk isi ulang tambahan.",
      ],
    },
  },
};
